__turbopack_context__.v({
  "active": "DefaultTotalAmount-module-scss-module__N-Ijsa__active",
  "content": "DefaultTotalAmount-module-scss-module__N-Ijsa__content",
  "date": "DefaultTotalAmount-module-scss-module__N-Ijsa__date",
  "wrap": "DefaultTotalAmount-module-scss-module__N-Ijsa__wrap",
});
